import React from 'react';
import classnames from 'classnames';
import { motion } from 'framer-motion';

import { Card } from 'uikit/cards';

import VideosCardContent from './videosCardContent';
import VideosCardMedia from './videosCardMedia';
import VideosCardSkeleton from './videosCardSkeleton';

import styles from '../styles/videosCard.module.scss';
import 'uikit/cards/styles/uikitCardsCardMedia.module.scss';

export default function VideosCard({
  id,
  className,
  image,
  layout,
  link,
  meta,
  metaIcon,
  testId,
  title,
  cardMedia,
  videoType,
  reputation,
  isComplete,
  progress,
  duration,
  voteTotal,
  isSkeletonLoading,
}) {
  return (
    <Card to={link} className={classnames(className, styles.item)} testId={testId}>
      <div
        id={id}
        className={classnames(styles.link, {
          [styles.isHorizontal]: layout === 'horizontal',
        })}
      >
        {isSkeletonLoading
          ? <VideosCardSkeleton /> : (
            <motion.div
              key="key"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <VideosCardMedia
                videoType={videoType}
                isComplete={isComplete}
                image={image}
                cardMedia={cardMedia}
                progress={progress}
                duration={duration}
              />
              <VideosCardContent
                title={title}
                meta={meta}
                metaIcon={metaIcon}
                reputation={reputation}
                voteTotal={voteTotal}
                videoType={videoType}
              />
            </motion.div>
          )}
      </div>
    </Card>
  );
}
